// extracted by mini-css-extract-plugin
export default {"body":"main_body__u7X+L","icon":"main_icon__l-Jb3","bodyLink":"main_bodyLink__z1E5s","image":"main_image__7r8bO","row":"main_row__BKZ-P"};